import {defineAsyncComponent} from 'vue';

const BeforeDataEstArrgrateBudgetCollectionDetail = defineAsyncComponent(() =>
  import(
    '@/views/beforeData/beforeDataEstArrgrateBudgetCollection/BeforeDataEstArrgrateBudgetCollectionDetail.vue'
  ),
);
const BeforeDataEstArrgrateBudgetCollectionAgency = defineAsyncComponent(() =>
  import(
    '@/views/beforeData/beforeDataEstArrgrateBudgetCollection/BeforeDataEstArrgrateBudgetCollectionAgency.vue'
  ),
);
const BeforeDataEstArrgrateBudgetCollection = defineAsyncComponent(() =>
  import('@/views/beforeData/beforeDataEstArrgrateBudgetCollection/BeforeDataEstArrgrateBudgetCollection.vue'),
);

const BeforeDataEstArrgrateBudgetDetailPopup = defineAsyncComponent(() =>
  import('@/views/beforeData/beforeDataEstArrgrateBudgetCollection/BeforeDataEstArrgrateBudgetDetailPopup.vue'),
);

export function registerBeforeData(app) {
  app.component('BeforeDataEstArrgrateBudgetCollectionDetail', BeforeDataEstArrgrateBudgetCollectionDetail);
  app.component('BeforeDataEstArrgrateBudgetCollectionAgency', BeforeDataEstArrgrateBudgetCollectionAgency);
  app.component('BeforeDataEstArrgrateBudgetCollection', BeforeDataEstArrgrateBudgetCollection);
  app.component('BeforeDataEstArrgrateBudgetDetailPopup', BeforeDataEstArrgrateBudgetDetailPopup);
}
